import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { BaseTableStyles } from '../base-table/base-table.styles';

export const medispanStagingStyles = (theme: Theme) =>
  createStyles({
    ...BaseTableStyles(theme),
    subHeaderCell: {
      ...BaseTableStyles(theme).tableHeadCell,
      fontSize: '0.75rem',
      fontWeight: 400,
      borderRight: `1px solid ${theme.palette.divider}`,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    subHeaderCellRight: {
      ...BaseTableStyles(theme).tableHeadCell,
      fontSize: '0.75rem',
      fontWeight: 400,
      borderBottom: `1px solid ${theme.palette.divider}`,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    changedValue: {
      color: '#B23A3A',
      fontWeight: 500,
    },
    userCell: {
      whiteSpace: 'nowrap',
      fontSize: '0.8rem',
      color: theme.palette.text.secondary,
    },
    emptyState: {
      padding: theme.spacing(4),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    tableCell: {
      ...BaseTableStyles(theme).tableCell,
      padding: theme.spacing(1.5),
    },
    rejectReasonField: {
      marginTop: theme.spacing(2),
    },
  });
